/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { getIsUserActionPending, getUsers } from '@app/user/store/users.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { User } from '@shared/models';
import { Observable } from 'rxjs';
import * as UserActions from '../store/users.actions';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    standalone: false
})
export class UserListComponent implements OnInit {
  tableColumns = [
    'firstName',
    'lastName',
    'shortHand',
    'roles',
    'actions'
  ];
  users: User[];
  dataSource: MatTableDataSource<User>;
  actionPending$: Observable<boolean>;

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.store.select(getUsers).subscribe(users => {
      this.users = users;
      this.dataSource = new MatTableDataSource(users.filter(user => user.enabled === true));
    });
    this.actionPending$ = this.store.select(getIsUserActionPending);
    this.store.dispatch(new UserActions.LoadUsers());
  }

  onChangeTab(tab): void {
    if (tab === 0) {
      this.dataSource = new MatTableDataSource(this.users.filter(user => user.enabled === true));
    } else {
      this.dataSource = new MatTableDataSource(this.users.filter(user => user.enabled === false));
    }
  }

  editUser(userId?: string): void {
    this.store.dispatch(new UserActions.EditUser(userId));
  }

  deactivateUser(user: User): void {
    this.store.dispatch(new UserActions.DeactivateUser(user));
  }
}
